import * as React from "react";

import {SearchKeywordService} from "../Services/SearchKeywordService";

interface ISearchBoxProps {
    placeholderText: string;
    searchPageUrl: string;
    language: string;
}

interface ISearchBoxState {
    searchQuery: string;
    matchingKeywords: any;
    selectedKeywordIndex: number;
}

class SearchBox extends React.Component<ISearchBoxProps, ISearchBoxState> {
    private service: SearchKeywordService;

    public constructor(props: ISearchBoxProps) {
        super(props);
        this.state = { searchQuery: "", matchingKeywords: [], selectedKeywordIndex: -1 };
        this.service = new SearchKeywordService(props.language);

        this.handleChange = this.handleChange.bind(this);
        this.handleKeydown = this.handleKeydown.bind(this);
    }

    public render() {
        const keywordResults = this.renderResults();
        return (
            <div>
               <form action={this.props.searchPageUrl} autoComplete="off" method="get" acceptCharset="utf-8">
                   <input type="hidden" name="ieEncodingFix" value="&#153;" />
                    <input
                        type="text"
                        className="header-search"
                        name="q"
                        placeholder={this.props.placeholderText}
                        value={this.state.searchQuery}
                        onChange={this.handleChange}
                        aria-label="header search"
                    />
                    <input type="submit" className="search-icon" aria-label="search button"/>
                </form>
                {
                    keywordResults &&
                    keywordResults.length > 0 &&
                    <ul className="search-keyword-suggestions">{keywordResults}</ul>
                }
                
            </div>
        );
    }

    public componentDidMount() {
        document.addEventListener("keydown", this.handleKeydown, true);
    }

    public componentWillUnmount() {
        document.removeEventListener("keydown", this.handleKeydown, false);
    }

    private loadKeywords(newQuery: string) {
        if (newQuery.length < 3) {
            this.setState({ ...this.state, matchingKeywords: [] });
        } else {
            this.service.getKeywords(newQuery)
                .then((result: any) => this.setState({ ...this.state, matchingKeywords: result }))
                .catch((error: any) => {
                    console.error("Error while loading search suggestions", error);
                    return this.setState({ ...this.state, matchingKeywords: [] });
                });
        }
    }

    private handleChange(event: React.ChangeEvent<HTMLInputElement>) {
        const newQuery = event.target.value;
        this.setState({...this.state, searchQuery: newQuery}, () => this.loadKeywords(newQuery));
    }

    private renderResults() {
        let selectedKeyword = "";
        if (this.state.matchingKeywords[this.state.selectedKeywordIndex]) {
            selectedKeyword = this.state.matchingKeywords[this.state.selectedKeywordIndex].keyword;
        }

        return this.state.matchingKeywords.map(
            (keyword: any) =>
            (
                <SearchResult
                    searchQuery={this.state.searchQuery}
                    keyword={keyword.keyword}
                    key={keyword.keyword}
                    target={this.props.searchPageUrl + keyword.query}
                    isActive={selectedKeyword === keyword.keyword}
                />
            ),
        );
    }

    private handleKeydown(event: KeyboardEvent) {
        if ((event.code  === "Esc" || event.code === "Escape") && this.state.matchingKeywords.length > 0) {
            this.setState({...this.state, matchingKeywords: [], selectedKeywordIndex: -1});
        }
        if (event.code === "ArrowDown" && this.state.matchingKeywords.length > 0) {
            if (this.state.selectedKeywordIndex < this.state.matchingKeywords.length) {
                this.setState({ selectedKeywordIndex: this.state.selectedKeywordIndex + 1});
            }
        }
        if (event.code === "ArrowUp" && this.state.matchingKeywords.length > 0) {
            if (this.state.selectedKeywordIndex > 0) {
                this.setState({ selectedKeywordIndex: this.state.selectedKeywordIndex - 1});
            }
        }
        if (event.code === "Enter" && this.state.matchingKeywords[this.state.selectedKeywordIndex]) {
            const query = this.state.matchingKeywords[this.state.selectedKeywordIndex].query;
            window.location.href = this.props.searchPageUrl + query;
        }
    }

}

interface ISearchResultProps {
    searchQuery: string;
    keyword: string;
    target: string;
    isActive: boolean;
}

// Gives matching keyword element, with matching part highlighted.
const SearchResult: React.FC<ISearchResultProps> = ({keyword, searchQuery, target, isActive}) => {
    const queryStartIndex = keyword.toLowerCase().indexOf(searchQuery.toLowerCase());

    const beforeMatch = keyword.substring(0, queryStartIndex);
    // This gets the original case of keyword, so we don't use just keyword
    const match = keyword.substring(queryStartIndex, queryStartIndex + searchQuery.length);
    const afterMatch = keyword.substring(queryStartIndex + searchQuery.length);
    return (
        <li className={`keyword-suggestion ${isActive ? "selected" : ""}`}>
            <a href={target}>
                {beforeMatch}
                <span className={`keyword-suggestion-match ${isActive ? "active aria-selected" : ""}`}>{match}</span>
                {afterMatch}
            </a>
        </li>
    );
};

export { SearchBox };
